import Template from "./popup.vue";
import store from "@/store";
import i18n from "@/i18n";

let globalOptions = {
  show: false,
  closable: true,
  title: {
    content: "",
    cssClass: "",
    style: {}
  },
  message: {
    content: "",
    cssClass: "",
    style: {}
  },
  buttons: [],
  closeBtn: {
    cssClass: "",
    style: {}
  },
  messageBox: {
    cssClass: "",
    style: {}
  },
  msgFooter: {
    cssClass: "",
    style: {}
  },
  fnSearchCallBack: function() {},
  fnCreateCallBack: function() {},
  fnCloseCallBack: function() {},
  fnGoPersonCard: function() {},
  team_id: null,
  event_id: null,
  api_url: process.env.VUE_APP_API_URL,
  user_token: localStorage.token,
  reject_document: [],
  reject_document_id: 1
};

let instance;

const Popup = function(config = {}) {
  let Tpl = this.extend(Template);
  instance = new Tpl();
  config = {
    ...globalOptions,
    ...config
  };
  for (let key in config) {
    if (config.hasOwnProperty(key)) {
      instance.$data[key] = config[key];
    }
  }
  instance.$data.show = true;
  document.body.style.overflow = "hidden";
  document.body.appendChild(instance.$mount().$el);
};

const Close = function(config = {}) {
  instance.$data.show = false;
  document.body.removeChild(instance.$mount().$el);
  instance = undefined;
};

const Alert = function(data, callback) {
  let alertConfig = {
    type: "info",
    message: {
      content: data.message
    },
    buttons: [
      {
        label: data.btnSuccess,
        style: {
          margin: "0",
          width: "100%",
          height: "40px",
          lineHeight: "40px",
          boxSizing: "border-box",
          border: "none"
        },
        action: function() {
          Dismiss();
          callback && callback();
        }
      }
    ],
    msgFooter: {
      style: {
        padding: "0"
      }
    }
  };

  Popup.call(this, {
    ...globalOptions,
    ...alertConfig
  });
};

const Confirm = function(confirm, callback, callbackCancel) {
  let confirmConfig = {
    type: "info",
    message: {
      content: confirm.message
    },
    buttons: [
      {
        label: confirm.btnSuccess,
        style: {
          margin: "0",
          padding: "0",
          width: "50%",
          height: "50px",
          boxSizing: "border-box",
          border: "none",
          borderRight: "1px solid #f8f8f8",
          lineHeight: "50px",
          float: "left"
        },
        action: function() {
          Dismiss();
          callback && callback(true);
        }
      },
      {
        label: confirm.btnError,
        style: {
          margin: "0",
          padding: "0",
          width: "50%",
          height: "40%",
          boxSizing: "border-box",
          border: "none",
          lineHeight: "50px",
          float: "left"
        },
        action: function() {
          Dismiss();
          callbackCancel && callbackCancel(false);
        }
      }
    ],
    msgFooter: {
      style: {
        padding: "0"
      }
    }
  };

  Popup.call(this, {
    ...globalOptions,
    ...confirmConfig
  });
};

const SearchPerson = function(params) {
  let searchPersonConfig = {
    type: "search_person",
    title: {
      content: params.title
    },
    message: {
      content: params.message
    },
    buttons: [
      {
        label: params.btnSearch,
        style: {
          margin: "0",
          padding: "0",
          width: "33%",
          height: "50px",
          boxSizing: "border-box",
          border: "none",
          borderRight: "1px solid #f8f8f8",
          lineHeight: "50px",
          float: "left",
          backgroundColor: "#172654",
          color: "#FFF"
        },
        cssClass: "search",
        action: "search"
      },
      {
        label: params.btnSuccess,
        style: {
          margin: "0",
          padding: "0",
          width: "33%",
          height: "50px",
          boxSizing: "border-box",
          border: "none",
          borderRight: "1px solid #f8f8f8",
          lineHeight: "50px",
          float: "left"
        },
        action: "create"
        // function(){
        //     // Dismiss();
        //     callback && callback(true);
        // }
      },
      {
        label: params.btnCancel,
        style: {
          margin: "0",
          padding: "0",
          width: "33%",
          height: "50px",
          boxSizing: "border-box",
          border: "none",
          lineHeight: "50px",
          float: "left"
        },
        action: "close"
      }
    ],
    msgFooter: {
      style: {
        padding: "0"
      }
    },
    fnSearchCallBack(self, store) {
      if (
        self.name.trim() == "" &&
        self.dni.trim() == "" &&
        self.email.trim() == ""
      ) {
      } else if (self.valid) {
        self.$overlay.loading();
        store
          .dispatch("persons/search", {
            name: self.name,
            dni: self.dni,
            email: self.email
          })
          .then(persons => {
            if (persons) {
              var aPersons = ObjectToArray(persons);
              aPersons.forEach(person => {
                if (person.current_roles.length > 0) {
                  var entity_name = "";
                  if (person.current_roles[0].team != null) {
                    entity_name = person.current_roles[0].team.name;
                  } else if (person.current_roles[0].club != null) {
                    entity_name = person.current_roles[0].club.name;
                  }

                  person.role = {
                    id: person.current_roles[0].contact_type.id,
                    name: person.current_roles[0].contact_type.name,
                    entity: entity_name
                  };
                } else {
                  person.role = {
                    id: -1,
                    name: "Sense rol",
                    entity: "N/A"
                  };
                }
              });

              self.persons = aPersons;
            } else {
              self.persons = [];
            }

            self.search = true;
            self.$overlay.hide();
          });
      }
    },
    fnCreateCallBack(self, store, router) {
      var event = store.getters.isEventSelected
        ? store.getters["events/getCurrentEvent"]()
        : false;
      var page = "persons_add";
      page = event ? "event_" + page : page;

      router.push({
        name: page,
        params: {
          event: event
            ? (event.name + event.edition.substring(2)).toLowerCase()
            : null,
          entity: params.entity,
          entity_id: params.id,
          type: params.type,
          action: "new_role"
        }
      });

      self.$popup.close();
    },
    fnCloseCallBack(self) {
      self.$popup.close();
    },
    fnGoPersonCard(self, router, id) {
      self.$popup.close();
      // router.push( { name: 'persons_card', params: { id: id } } )
      var event = store.getters.isEventSelected
        ? store.getters["events/getCurrentEvent"]()
        : false;
      var page = "persons_edit";
      page = event ? "event_" + page : page;

      router.push({
        name: page,
        params: {
          id: id,
          event: event
            ? (event.name + event.edition.substring(2)).toLowerCase()
            : null,
          entity: params.entity,
          entity_id: params.id,
          type: params.type,
          action: "new_role"
        }
      });
    }
  };

  Popup.call(this, {
    ...globalOptions,
    ...searchPersonConfig
  });
};

const MyTeams = function(params, callback, callbackCancel) {
  let myTeamsConfig = {
    type: "myteams",
    team_id: params.team_id,
    event_id: params.event_id,
    user_token: localStorage.token,
    buttons: [
      {
        label: params.btnSuccess,
        style: {
          margin: "0",
          padding: "0",
          width: "50%",
          height: "50px",
          boxSizing: "border-box",
          border: "none",
          borderRight: "1px solid #f8f8f8",
          lineHeight: "50px",
          float: "left"
        },
        action: function() {
          Dismiss();
          callback && callback(true);
        }
      },
      {
        label: params.btnError,
        style: {
          margin: "0",
          padding: "0",
          width: "50%",
          height: "40%",
          boxSizing: "border-box",
          border: "none",
          lineHeight: "50px",
          float: "left"
        },
        action: function() {
          Dismiss();
          callbackCancel && callbackCancel(false);
        }
      }
    ],
    msgFooter: {
      style: {
        padding: "0"
      }
    }
  };

  Popup.call(this, {
    ...globalOptions,
    ...myTeamsConfig
  });
};

const RejectDocument = function(params, callback) {
  var aRejects = [];
  Object.values(params.reject_document).forEach(reject => {
    aRejects.push({
      text: i18n.t(reject.name),
      value: parseInt(reject.id)
    });
  });
  let rejectDocumentConfig = {
    type: "reject_document",
    reject_document: aRejects,
    closable: false,
    title: {
      content: params.title
    },
    message: {
      content: params.message
    },
    buttons: [
      {
        label: params.btnSuccess,
        style: {
          margin: "0",
          padding: "0",
          width: "50%",
          height: "50px",
          boxSizing: "border-box",
          border: "none",
          borderRight: "1px solid #f8f8f8",
          lineHeight: "50px",
          float: "left"
        },
        action: "create"
      }
    ],
    msgFooter: {
      style: {
        padding: "0"
      }
    }
  };

  rejectDocumentConfig.fnCreateCallBack = callback;

  Popup.call(this, {
    ...globalOptions,
    ...rejectDocumentConfig
  });
};

const Dismiss = () => {
  instance.$data.show = false;
  document.body.style.overflow = "auto";
};

export default {
  install(Vue) {
    Vue.prototype.$popup = Popup.bind(Vue);
    Vue.prototype.$popup.alert = Alert.bind(Vue);
    Vue.prototype.$popup.confirm = Confirm.bind(Vue);
    Vue.prototype.$popup.searchperson = SearchPerson.bind(Vue);
    Vue.prototype.$popup.myTeams = MyTeams.bind(Vue);
    Vue.prototype.$popup.rejectDocument = RejectDocument.bind(Vue);

    Vue.prototype.$popup.close = Close.bind(Vue);
  }
};
